import React from 'react';
import { Image } from '@noths/polaris-client-ribbons-design-system';

import type { Product } from '../../../../types/dontgiftguide';
import { parseCopy } from '../../../../utils/parseCopy';
import { ProductLabel } from '../../atoms/ProductLabel/ProductLabel';
import { Content } from '../../molecules/Content/Content';
import { singleSnowflakeDarkURL, singleSnowflakeURL } from './PartnerSection.styles';
import * as styles from './PartnerSection.styles';

export interface PartnerSectionProps {
  onLinkClick: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  partnerImage: string;
  copy: string;
  darkCopyColor: boolean;
  backgroundColor: string;
  product?: Product;
}

export const PartnerSection = (props: PartnerSectionProps) => {
  const { onLinkClick, partnerImage, copy, darkCopyColor, backgroundColor, product } = props;
  const parsedCopy = parseCopy(copy);

  const snowflakeImageURL = darkCopyColor ? singleSnowflakeDarkURL : singleSnowflakeURL;

  return product ? (
    <Content darkCopyColor={darkCopyColor}>
      <div css={styles.partnerSection} style={{ backgroundColor }}>
        <a css={styles.link} href={product.href} onClick={onLinkClick}>
          <Image src={product.image.original} alt="" css={styles.productImage} loading="lazy" />
          <Image src={partnerImage} alt="" css={styles.partnerImage} loading="lazy" />
          <div css={styles.description}>
            {parsedCopy && <p css={styles.copy}>{parsedCopy}</p>}
            <p css={styles.productLabel}>
              <ProductLabel product={product} />
            </p>
          </div>
          <img src={snowflakeImageURL} alt="" css={styles.snowflake} />
        </a>
      </div>
    </Content>
  ) : null;
};
